import { StoreAttributes } from '@pylot-data/hooks/product/graphql/Fragments/StoreAttributes'
import { DefaultCategory } from '@pylot-data/hooks/product/graphql/Fragments/DefaultCategory'
export const ProductItemFragment = /* GraphQL */ `
    __typename
    id
    uid
    name
    sku
    url_key
    attribute_set_name
    brand
    brand_text
    stock_status
    flavour
    flavour_text
    product_eyebrow_badge
    product_eyebrow_badge_text
    faq
    assembly_care
    whats_in_box
    warranty
    small_image {
        __typename
        url
    }
    short_description {
        html
    }
    thumbnail {
        url
    }
    categories {
        name
        url_path
        breadcrumbs {
            category_id
            category_name
        }
    }
    ${DefaultCategory}
    mp_label_data {
      priority
      label_template
      label_image
      same
      list_template
      list_image
    }
    price_range {
        __typename
        minimum_price {
            __typename
            regular_price {
                __typename
                value
                currency
            }
            final_price {
                __typename
                value
                currency
            }
            discount {
                __typename
                amount_off
            }
        }
        maximum_price {
            __typename
            final_price {
                __typename
                value
                currency
            }
          discount {
            percent_off
          }
        }
    }
    description_title
    whats_in_box_title
    warranty_title
    assembly_care_title
    faq_title
    subtitle
    addtocart_popup_cms
    ${StoreAttributes}
    is_tobacco_product
`
